(() => {
  'use strict';
  const configNode = document.getElementById('tiny-hilts-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const el = id => document.getElementById(id);
  let language = document.documentElement.lang.startsWith('fr') ? 'fr' : 'en';
  let cart = config.cart;
  let busy = false;
  const parameters = new URLSearchParams(location.search);
  let bundleTarget = parameters.get('bundle') === '4' ? 4 : parameters.get('bundle') === '2' ? 2 : 0;
  if (parameters.get('lang') === 'fr') language = 'fr';
  const t = (en, fr) => language === 'fr' ? fr : en;
  const money = cents => new Intl.NumberFormat(language === 'fr' ? 'fr-CA' : 'en-CA', { style: 'currency', currency: cart.currency || config.currency, currencyDisplay: 'code' }).format(cents / 100);
  const safe = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const status = message => { if (el('status')) el('status').textContent = message; };
  const endpoint = name => `${config.root.replace(/\/?$/, '/')}cart/${name}.js`;
  async function readCart() {
    const response = await fetch(`${config.root.replace(/\/?$/, '/')}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(t('Your bag could not be loaded. Please try again.', 'Impossible de charger le panier. Réessayez.'));
    cart = await response.json();
    renderCart();
  }
  function renderCart() {
    const count = cart.item_count || 0;
    const productId = el('product-grid')?.dataset.productId;
    const necklaceCount = cart.items.filter(item => String(item.product_id) === productId).reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('[data-bundle]').forEach(link => {
      if (Number(link.dataset.bundle) === bundleTarget) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    if (el('bundle-instruction')) el('bundle-instruction').textContent = bundleTarget ? t(`Your ${bundleTarget === 2 ? 'Duo' : 'Squad'}: ${Math.min(necklaceCount, bundleTarget)} of ${bundleTarget} necklaces selected. Add your designs below.`, `Votre ${bundleTarget === 2 ? 'duo' : 'escouade'} : ${Math.min(necklaceCount, bundleTarget)} colliers sélectionnés sur ${bundleTarget}. Ajoutez vos modèles ci-dessous.`) : '';
    if (el('bundle-progress')) el('bundle-progress').textContent = necklaceCount >= 4 ? t('Squad pricing unlocked: $20 CAD per necklace.', 'Prix escouade débloqué : 20 $ CA par collier.') : necklaceCount >= 2 ? t(`Duo pricing unlocked. Add ${4 - necklaceCount} more for $20 CAD each.`, `Prix duo débloqué. Ajoutez ${4 - necklaceCount} colliers pour passer à 20 $ CA chacun.`) : t(`Add ${2 - necklaceCount} ${necklaceCount === 1 ? 'more necklace' : 'necklaces'} to unlock 2 for $50 CAD.`, `Ajoutez ${2 - necklaceCount} ${necklaceCount === 1 ? 'collier' : 'colliers'} pour profiter de 2 pour 50 $ CA.`);
    if (el('bundle-savings')) {
      el('bundle-savings').hidden = !(cart.total_discount > 0);
      el('bundle-savings').textContent = t('Automatic savings: ', 'Économies automatiques : ') + money(cart.total_discount || 0);
    }
    if (el('bag-count')) el('bag-count').textContent = count;
    if (el('subtotal')) el('subtotal').textContent = money(cart.total_price);
    if (el('selection-items')) {
      el('selection-items').innerHTML = cart.items.length ? cart.items.map(item => {
        const name = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : item.product_title;
        return `<div class="selection-row">${item.image ? `<img src="${safe(item.image)}" alt="" width="44" height="54">` : '<span></span>'}<div><p class="selection-name">${safe(name)}</p><div class="selection-row-bottom"><div class="quantity"><button type="button" data-key="${safe(item.key)}" data-step="-1" aria-label="${safe(t('Decrease quantity for ', 'Réduire la quantité de ') + name)}" ${busy ? 'disabled' : ''}>−</button><span>${item.quantity}</span><button type="button" data-key="${safe(item.key)}" data-step="1" aria-label="${safe(t('Increase quantity for ', 'Augmenter la quantité de ') + name)}" ${busy ? 'disabled' : ''}>+</button></div><span>${money(item.final_line_price)}</span></div><button type="button" class="remove" data-remove="${safe(item.key)}" ${busy ? 'disabled' : ''} aria-label="${safe(t('Remove ', 'Retirer ') + name)}">${t('Remove', 'Retirer')}</button></div></div>`;
      }).join('') : `<p class="empty-selection">${t('Your favourites belong here. Choose a design to start your collection.', 'Vos favoris ont leur place ici. Choisissez un modèle pour commencer.')}</p>`;
    }
    if (el('checkout')) { el('checkout').disabled = busy || count === 0; el('checkout').classList.toggle('disabled', busy || count === 0); }
    if (el('mobile-bag')) {
      el('mobile-bag').hidden = count === 0 || !el('selection-items');
      el('mobile-count').textContent = `${count} ${t(count === 1 ? 'necklace' : 'necklaces', count === 1 ? 'collier' : 'colliers')}`;
      el('mobile-total').textContent = money(cart.total_price);
    }
  }
  function setBusy(value) {
    busy = value;
    document.querySelectorAll('.necklace-form button').forEach(button => {
      if (button.dataset.originalDisabled === undefined) button.dataset.originalDisabled = String(button.disabled);
      button.disabled = value || button.dataset.originalDisabled === 'true';
    });
    if (el('your-selection')) el('your-selection').setAttribute('aria-busy', String(value));
    renderCart();
  }
  async function mutate(name, body) {
    if (busy) return;
    setBusy(true);
    status(t('Updating your bag…', 'Mise à jour du panier…'));
    try {
      const response = await fetch(endpoint(name), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || t('Unable to update your bag.', 'Impossible de mettre à jour le panier.'));
      await readCart();
      status(t('Your bag is updated.', 'Votre panier est à jour.'));
    } catch (error) {
      try { await readCart(); } catch {}
      status(error.message);
    } finally { setBusy(false); }
  }
  document.addEventListener('submit', event => {
    if (!event.target.matches('.necklace-form')) return;
    event.preventDefault();
    const data = new FormData(event.target);
    void mutate('add', { items: [{ id: String(data.get('id')), quantity: 1 }] });
  });
  document.addEventListener('click', async event => {
    const bundle = event.target.closest('[data-bundle]');
    if (bundle) { bundleTarget = Number(bundle.dataset.bundle); renderCart(); }
    const button = event.target.closest('[data-key],[data-remove]');
    if (!button || busy) return;
    const key = button.dataset.key || button.dataset.remove;
    const item = cart.items.find(row => row.key === key);
    if (!item) return;
    const step = button.dataset.step;
    await mutate('change', { id: key, quantity: button.dataset.remove ? 0 : Math.max(0, item.quantity + Number(step)) });
    const next = [...document.querySelectorAll('[data-key],[data-remove]')].find(node => (node.dataset.key || node.dataset.remove) === key && node.dataset.step === step);
    if (next) next.focus(); else if (el('selection-title')) { el('selection-title').tabIndex = -1; el('selection-title').focus({ preventScroll: true }); }
  });
  function applyLanguage() {
    document.documentElement.lang = language;
    document.querySelectorAll('[data-en][data-fr]').forEach(node => { node.textContent = node.dataset[language]; });
    if (el('language')) {
      el('language').textContent = language === 'en' ? 'FR' : 'EN';
      el('language').lang = language === 'en' ? 'fr' : 'en';
      el('language').setAttribute('aria-label', t('Voir en français', 'View in English'));
    }
    renderCart();
  }
  el('language')?.addEventListener('click', () => { language = language === 'en' ? 'fr' : 'en'; applyLanguage(); });
  applyLanguage();
  window.addEventListener('pageshow', event => { if (event.persisted) void readCart().catch(error => status(error.message)); });
})();
